module.exports = __webpack_public_path__ + "assets/instagram-list-view-icon.367e8b73.svg";